import {Injectable} from '@angular/core';
import {ErweiterungConfigResponse} from "../core/base-api";
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Injectable({
  providedIn: 'root'
})
export class SecurityData {

  actionUrl: string;
  erweiterung: ActiveErweiterungenEnum[];
  kanton: string[];

  constructor() { }
}
